export default __webpack_public_path__ + "static/media/male-endomorph.edd4f2c8.svg";